import { render } from "./ImgUploadNew.vue?vue&type=template&id=40f80bcd&scoped=true"
import script from "./ImgUploadNew.vue?vue&type=script&lang=js"
export * from "./ImgUploadNew.vue?vue&type=script&lang=js"

import "./ImgUploadNew.vue?vue&type=style&index=0&id=40f80bcd&scoped=true&lang=css"
import "./ImgUploadNew.vue?vue&type=style&index=1&id=40f80bcd&lang=css"

import exportComponent from "D:\\newProjectGit\\HbzsbAdminClient\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40f80bcd"]])

export default __exports__